import {SensorAvailabilityStatus} from '@lib/infrastructure';
import {getMeetingRoomSuggestionDataById, useAppSelector} from '@lib/store';
import {useTranslation} from 'react-i18next';
import {getSensorLastUpdatedText} from '@lib/store/src/data/sensors';
import {IndicatorStatus} from './types';

export type SensorStatus = {
  sensorStatus: IndicatorStatus;
  sensorTitle: string;
  sensorSubtitle?: string;
};

export const useRoomSensorStatus = (buildingId: string, roomId: string): SensorStatus | undefined => {
  const {t} = useTranslation();
  const {sensorStateTimestamp, sensorAvailability} =
    useAppSelector((state) => getMeetingRoomSuggestionDataById(state, buildingId, roomId)) ?? {};

  const updateTimeLabelText = getSensorLastUpdatedText(t, sensorStateTimestamp);

  switch (sensorAvailability) {
    case SensorAvailabilityStatus.Available: {
      return {
        sensorStatus: 'success',
        sensorTitle: t('hereAndNow:RoomSeemsToBeAvailableTitle'),
        sensorSubtitle: updateTimeLabelText,
      };
    }
    case SensorAvailabilityStatus.Occupied: {
      return {
        sensorStatus: 'error',
        sensorTitle: t('hereAndNow:RoomSeemsToBeInUseTitle'),
        sensorSubtitle: updateTimeLabelText,
      };
    }
    case SensorAvailabilityStatus.Away: {
      return {
        sensorStatus: 'unknown',
        sensorTitle: t('hereAndNow:RoomLiveDataUnavailableTitle'),
        sensorSubtitle: updateTimeLabelText,
      };
    }
    case SensorAvailabilityStatus.Unknown:
    default: {
      return;
    }
  }
};
